<div class="col-12">
    <div *ngIf="loginServices.hasRoles(['cliente_ventanilla','ministro','gerente','jefe'])" class="card p-0 grid grid-nogutter">
        <ng-container *ngFor="let item of itemsDashboardAutorizacionesService.getItemsProfesionales()">
            <div class="col-12 md:col-6 lg:col-2 py-5 px-6 border-none md:border-right-1 surface-border">
                <div class="flex align-items-center mb-1">
                    <span class="text-2xl ml-2">{{ item.title }}</span>
                </div>
                <div class="flex align-items-center mb-1">
                    <div [routerLink]="item.routerLink" class="cursor-pointer">
                        <div class="retract" style="">
                            <img class="color-image" [style]="{'width':'50%'}" [src]="item.imageSrc">
                        </div>
                    </div>
                </div>
                <div class="border-round overflow-hidden surface-200" style="height:.3rem">
                    <div class="h-full" [ngClass]="item.bgColor" style="width:100%"></div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
